<template lang="pug">
main
  router-view(name="TheHeader")
  b-container
    router-view
  router-view(name="TheFooter")
  a-back-top
  b-container
    hr
</template>

<script>
export default {
  name: 'App',
};
</script>

<style>
body {
  background-color: #f7f7f7;
  font-family: "Montserrat", sans-serif;
}
</style>
